// extracted by mini-css-extract-plugin
export var storyblokButton = "storyblok-button-module--storyblok-button--28e21";